<template>
    <div class="list--container">
        <div class="list">
            <heading :text="fields.heading" size="large"></heading>
            <p v-text="fields.sub_heading"></p>
            <div v-for="(item, index) in fields.list_items" :key="index">
                <p v-text="item.text" class="list--line-height"></p>
            </div>
            <div class="mt-4">
                 <heading :text="fields.donation_deadline" size="small"></heading>
                 <div class="img-container">
                     <div v-for="(item, index) in fields.image_banner_items" :key="index">
                         <img class="list--img-height" :src="item.image" />
                     </div>
                 </div>
             </div>
        </div>
        <div class="list--background-container">
            <img class="list--background-image--desktop" src="https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/homepage/PAPER-BACKGROUND-DESKTOP.png" alt="Paper background" />
            <img class="list--background-image--mobile" src="https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/homepage/PAPER-BACKGROUND-MOBILE.png" alt="Paper background"  />
        </div>
    </div>

</template>

<script>
import { Heading } from '@freddiesflowers/frontend-component-library';

export default {
    name: 'list',
    props: {
        fields: {
            type: Object,
        },
    },
    components: {
        Heading,
    },
};
</script>

<style lang="scss" scoped>
    .list--container{
        position: relative;
        text-align: center;
    }
    .list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        top: 0;
        width: 80%;
        margin: 0 10%;
        height: 100%;
        &--background-image {
            &--desktop {
                display: none;
            }
            &--mobile {
                max-width: unset;
                width: 100%;
                min-height: 800px;
            }
        }
        &--background-container {
            display: block;
            width: 100%;
        }
        &--line-height {
            line-height: 10px;
        }
        &--img-height {
            height: 4rem;
        }
    }
    .img-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }
    @media (min-width: 768px) {
        .list {
            width: 60%;
            margin: 0 20%;
            &--background-image {
                &--desktop {
                    display: block;
                    width: max-content;
                    min-height: 700px;
                }
                &--mobile {
                    display: none;
                }
            }
            &--line-height {
                line-height: 15px;
            }
            &--img-height {
                height: 5rem;
            }
        }
    }
    @media (min-width: 1024px) {
        .list {
            width: 50%;
            margin: 0 25%;
        }
        .list--background-image--desktop {
            width: 100%;
            min-height: 800px;
        }
    }
    @media (min-width: 1380px) {
        .list--background-image--desktop {
            width: 100%;
            min-height: 700px;
        }
    }
</style>
